import React, { useContext } from "react";

import { useForm } from "antd/lib/form/Form";
import { useMutation } from "@tanstack/react-query";
import { App, Button, Col, Form, Input, Row } from "antd";
import { AxiosError, HttpStatusCode } from "axios";

import { AreaRestritaUsuarioService, PayloadDeNovaSenha } from "../../../Services/Domain/AreaRestrita/UsuarioService";
import { RegrasComunsDeValidacaoDaAR } from "../../Utils/RegrasComunsDeValidacaoDaAR";
import { SessaoARContext } from "../../Contexts/SessaoContext";
import { notificarErroNaRequisicao, PropriedadesDeNotificacao } from "../../../Utils/Notificacoes";

interface IFormularioDeNovaSenha {
    senhaAtual: string,
    novaSenha: string,
    confirmacaoDaNovaSenha: string
}

export const AlterarSenhaAR: React.FC<{
    depoisDeFinalizar?: () => any
}> = (props) => {
    const { notification } = App.useApp();
    const [form] = useForm<IFormularioDeNovaSenha>();

    const SessaoAR = useContext(SessaoARContext);

    const alterarSenha = useMutation({
        mutationFn: (valores: IFormularioDeNovaSenha) => {
            const usuario = SessaoAR?.sessao?.usuario?.email ?? SessaoAR?.sessao?.usuario?.senha;
            if(usuario == null){
                return Promise.reject("Ocorreu um erro inesperado");
            }

            const payload: PayloadDeNovaSenha = {
                senhaAtual: valores.senhaAtual,
                novaSenha: valores.novaSenha
            }

            return new AreaRestritaUsuarioService().alterarSenha(
                payload, 
                { skipUnauthorizedLogout: true }
            );
        },
        onSuccess: (data) => {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso("Senha alterada com sucesso")
            })
            props.depoisDeFinalizar?.();
        },
        onError: (error: AxiosError) => {
            if (error.response?.status === HttpStatusCode.Unauthorized){
                notification.error(
                    PropriedadesDeNotificacao.Erro("Senha atual incorreta.")
                )
            }
            else{
                notificarErroNaRequisicao(error)
            }
        }
    });

    function aoFinalizar(values: IFormularioDeNovaSenha) {
        alterarSenha.mutate(values);
    }

    return (
        <Form<IFormularioDeNovaSenha>
            onFinish={aoFinalizar}
            form={form}
            layout="vertical"
            autoComplete="off"
        >
            <Row>
                <Col xs={24}>
                    <Form.Item<IFormularioDeNovaSenha>
                        name="senhaAtual"
                        label="Senha Atual"
                        rules={[{ min: 6, max: 20, required: true, message: "Infome sua senha atual." }]}
                    >
                        <Input.Password />
                    </Form.Item>
                </Col>

                <Col xs={24}>
                    <Form.Item<IFormularioDeNovaSenha>
                        name="novaSenha"
                        label="Nova Senha"
                        rules={RegrasComunsDeValidacaoDaAR.Senha}
                    >
                        <Input.Password />
                    </Form.Item>
                </Col>


                <Col xs={24}>
                    <Form.Item<IFormularioDeNovaSenha>
                        name="confirmacaoDaNovaSenha"
                        label="Confirmar Senha"
                        dependencies={["novaSenha"]}
                        rules={[
                            {
                                required: true,
                                message: 'Confirme sua senha.',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (getFieldValue('novaSenha') !== value) {
                                        return Promise.reject(new Error("A nova senha e a confirmação não conferem."));
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input.Password visibilityToggle={false}/>
                    </Form.Item>
                </Col>

            </Row >

            <Row gutter={16}  style={{marginTop: "1em"}}>
                <Col xs={24} style={{display: "flex", justifyContent: "center"}}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={alterarSenha.isPending}>
                            Alterar senha
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}